import { useSubscription } from '@terminal/stores/use-subscription/useSubscription';
import { useNavigateToCheckout } from '@terminal/views/settings/subscription/hooks/use-navigate-to-checkout/useNavigateToCheckout';

import { AlertPaymentMethod } from './components/alert-payment-method/AlertPaymentMethod';
import { AlertTrialEnds } from './components/alert-trial-ends/AlertTrialEnds';
import styles from './NotificationAlerts.module.scss';

export const NotificationAlerts = () => {
  const { card, userSubscription, cardError } = useSubscription(state => ({
    userSubscription: state.userSubscription,
    card: state.card,
    cardError: state.cardError,
  }));

  const upgradeToPro = useNavigateToCheckout();

  return (
    <div
      className={styles.notificationAlertsRoot}
      data-testid="notification-alerts"
    >
      <AlertTrialEnds upgradeToPro={upgradeToPro} />
      {card && (
        <AlertPaymentMethod
          card={card}
          userSubscription={userSubscription}
          cardError={cardError}
        />
      )}
    </div>
  );
};
